import { JobRatioCell } from './job-ratio-cell.model';

export class AcuityCell extends JobRatioCell {
    acuityCategory: string;
    acuityCategoryId: number;
}